var _rect, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBanner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 178,
    viewBox: "0 0 320 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    width: 320,
    height: 177,
    rx: 8,
    fill: "url(#paint0_linear_255_8311)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_255_8311",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 39,
    y: 13,
    width: 210,
    height: 165
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 13,
    width: 209.087,
    height: 164.172,
    fill: "#E5F3FB"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_255_8311)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.636 59.1867C123.525 58.5965 124.579 56.5864 123.99 54.6956C123.4 52.8049 121.391 51.7499 119.501 52.3401C117.611 52.9303 116.558 54.9412 117.147 56.8319C117.737 58.7226 119.746 59.7769 121.636 59.1875M64.9817 80.7245L96.5253 70.8773C96.8577 68.1891 98.7182 65.7991 101.46 64.943L111.995 61.6541C113.604 61.1518 114.512 59.4217 114.009 57.8103C112.879 54.1858 114.899 50.3307 118.522 49.1998C122.144 48.069 125.997 50.0911 127.128 53.7149C127.631 55.3264 129.36 56.2334 130.97 55.7303L141.505 52.4414C144.246 51.5862 147.135 52.4932 148.937 54.5154L180.479 44.6689L224.908 187.137C206.748 208.77 179.517 222.525 149.072 222.525C133.696 222.525 119.14 219.018 106.157 212.76L64.9817 80.7245Z",
    fill: "#0E2F4D",
    fillOpacity: 0.14
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.4102 71.5553L190.276 40.2244L228.432 182.697C210.379 206.873 181.552 222.525 149.07 222.525C135.926 222.525 123.383 219.955 111.907 215.302L73.4102 71.5553Z",
    fill: "#0762C8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.5864 76.2049L187.26 47.3391L224.751 187.328C218.088 196.425 208.738 203.681 199.586 208.969C173.793 223.872 144.948 226.959 117.383 217.34L79.5864 76.2049Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.863 48.6451C160.711 49.5019 162.182 51.1396 162.747 53.2504L164.586 60.1158L110.341 74.6583L108.503 67.7929C107.938 65.6821 108.395 63.5286 109.566 61.8616L158.863 48.6451Z",
    fill: "#021A30"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.898 52.3394C132.81 51.8266 133.945 49.8607 133.432 47.9475C132.919 46.0342 130.955 44.8988 129.042 45.4117C127.13 45.9246 125.995 47.8904 126.508 49.8037C127.02 51.7169 128.985 52.8523 130.898 52.3394ZM110.504 57.2713L121.164 54.4134C122.793 53.9771 123.769 52.2854 123.332 50.6552C122.35 46.9871 124.526 43.2176 128.191 42.2347C131.857 41.2525 135.625 43.4286 136.607 47.0959C137.044 48.7261 138.735 49.703 140.364 49.266L151.023 46.4081C154.798 45.3959 158.713 47.6576 159.724 51.4346L161.563 58.3008L107.318 72.8433L105.48 65.9771C104.469 62.2001 106.728 58.2827 110.503 57.2713H110.504Z",
    fill: "#B3CBDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.544 54.5009L106.3 69.0432L107.317 72.8416L161.561 58.2994L160.544 54.5009Z",
    fill: "#6F8393"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.683 96.4892L96.7056 100.504L100.719 115.489L115.696 111.474L111.683 96.4892ZM95.3967 99.028L112.077 94.5557L112.929 94.3274L113.157 95.1797L117.627 111.869L117.855 112.721L117.003 112.95L100.322 117.422L99.4705 117.65L99.2423 116.798L94.7731 100.109L94.5449 99.2563L95.3967 99.028Z",
    fill: "#92ADCF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.656 112.122C107.32 112.212 106.95 112.174 106.626 111.987L100.969 108.719C99.9907 108.153 99.6545 106.898 100.22 105.919C100.785 104.941 102.04 104.604 103.017 105.169L106.302 107.067L111.652 97.7963C112.217 96.8179 113.472 96.4815 114.45 97.0462C115.428 97.6116 115.764 98.8671 115.2 99.8455L108.48 111.49C108.294 111.814 107.992 112.032 107.656 112.122Z",
    fill: "#0762C8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.524 129.499C115.532 130.838 110.539 132.176 105.547 133.514C106.884 138.509 108.222 143.504 109.56 148.499C114.552 147.161 119.545 145.822 124.537 144.484C123.199 139.489 121.861 134.494 120.524 129.499ZM104.238 132.038C109.799 130.548 115.359 129.057 120.919 127.567C121.202 127.491 121.487 127.414 121.771 127.338C121.846 127.622 121.923 127.907 121.999 128.191C123.488 133.754 124.978 139.317 126.468 144.88C126.544 145.164 126.62 145.448 126.696 145.732C126.412 145.809 126.128 145.885 125.844 145.961C120.284 147.451 114.724 148.942 109.164 150.433C108.88 150.509 108.595 150.585 108.312 150.661C108.236 150.377 108.159 150.093 108.084 149.809C106.594 144.245 105.103 138.682 103.614 133.119C103.538 132.835 103.461 132.55 103.385 132.266C103.669 132.191 103.954 132.114 104.237 132.038H104.238Z",
    fill: "#92ADCF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.496 145.135C116.161 145.225 115.791 145.187 115.467 145C113.581 143.911 111.695 142.822 109.809 141.732C108.832 141.167 108.495 139.911 109.06 138.933C109.625 137.954 110.88 137.618 111.858 138.183C112.953 138.815 114.047 139.448 115.143 140.08C116.926 136.99 118.709 133.9 120.492 130.81C121.057 129.831 122.312 129.495 123.29 130.06C124.268 130.625 124.604 131.881 124.04 132.859C121.8 136.74 119.56 140.622 117.32 144.503C117.133 144.827 116.831 145.045 116.496 145.135",
    fill: "#0762C8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.367 162.513C124.374 163.852 119.382 165.19 114.39 166.528C115.727 171.523 117.065 176.518 118.403 181.513C123.395 180.175 128.387 178.836 133.38 177.498C132.042 172.503 130.704 167.508 129.367 162.513ZM113.081 165.052C118.641 163.561 124.202 162.07 129.761 160.579C130.045 160.503 130.33 160.427 130.613 160.351C130.689 160.635 130.766 160.919 130.841 161.203C132.331 166.767 133.821 172.33 135.311 177.893C135.387 178.177 135.464 178.462 135.54 178.746C135.256 178.821 134.971 178.898 134.688 178.974C129.128 180.464 123.568 181.955 118.007 183.445C117.723 183.522 117.439 183.598 117.155 183.674C117.079 183.39 117.003 183.105 116.927 182.821C115.437 177.258 113.948 171.695 112.457 166.132C112.381 165.848 112.305 165.564 112.229 165.28C112.513 165.204 112.797 165.127 113.081 165.052Z",
    fill: "#92ADCF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.337 178.147C125.002 178.237 124.632 178.199 124.307 178.012C122.421 176.923 120.536 175.833 118.65 174.745C117.672 174.179 117.336 172.924 117.9 171.945C118.465 170.967 119.72 170.63 120.698 171.195C121.793 171.828 122.888 172.46 123.983 173.093C125.766 170.003 127.549 166.913 129.333 163.822C129.898 162.844 131.153 162.507 132.131 163.072C133.108 163.637 133.445 164.893 132.88 165.871C130.641 169.753 128.401 173.634 126.161 177.515C125.973 177.84 125.672 178.057 125.336 178.148",
    fill: "#0762C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.242 84.807L122.014 100.954L122.412 102.44L182.64 86.2932L182.242 84.807Z",
    fill: "#92ADCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.591 92.0035L123.698 107.256L124.096 108.742L180.989 93.4897L180.591 92.0035Z",
    fill: "#92ADCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.905 81.891L120.324 94.6469L120.722 96.133L168.303 83.3771L167.905 81.891Z",
    fill: "#0762C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.058 117.559L130.857 133.966L131.255 135.452L192.456 119.045L192.058 117.559Z",
    fill: "#92ADCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.72 127.087L132.547 140.269L132.945 141.755L182.118 128.573L181.72 127.087Z",
    fill: "#92ADCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.06 112.409L129.167 127.661L129.565 129.148L186.458 113.895L186.06 112.409Z",
    fill: "#0762C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.557 155.756L139.695 166.979L140.093 168.465L181.955 157.242L181.557 155.756Z",
    fill: "#92ADCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.025 164.264L141.385 173.282L141.783 174.768L175.423 165.75L175.025 164.264Z",
    fill: "#92ADCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.904 145.424L138.011 160.677L138.409 162.163L195.302 146.91L194.904 145.424Z",
    fill: "#0762C8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_255_8311",
    x1: 8.45528,
    y1: 177,
    x2: 313.496,
    y2: 177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE8F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5F3FB",
    stopOpacity: 0.65
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanner);
export default __webpack_public_path__ + "static/media/banner.deece8c7537d7cac99f117fb5c1fdade.svg";
export { ForwardRef as ReactComponent };